import { useEffect, useState } from "react";
import { translationSettingsStore } from "../../stores/sessionStore";
import { useStore } from "@nanostores/react";

const TranslationSettings=()=>{
    const [translationSettings, setTranslationSettings] = useState(() => {
        const savedSettings = JSON.parse(localStorage.getItem("translationSettings"));
        return savedSettings || {
          translit: true,
          asdTranslate: true,
          malikTranslate: true,
          mustafaTranslate: true,
          piktcalTranslate: true,
          yusufTranslate: true,
        };
    });

    const checkAllTranslationStatus = () => {
        // Exclude 'translit' and check if all other translations are false
        const settingsToCheck = Object.entries(translationSettings).filter(([key]) => key !== 'translit');
        
        // Check if all translation settings (excluding 'translit') are false
        const allTranslationsFalse = settingsToCheck.every(([key, value]) => value === false);

        if (allTranslationsFalse) {
            // If all are false (excluding 'translit'), execute the true part
            const cards = document.querySelectorAll('.emptyMessage');
            cards.forEach((item) => {
                item.classList.remove('hidden');
            });
        } else {
            // If not all are false (excluding 'translit'), execute the false part
            const cards = document.querySelectorAll('.emptyMessage');
            cards.forEach((item) => {
                item.classList.add('hidden');
            });
        }
    };

    const toggleTranslationPageCards=(cardType,toggleState)=>{
        // Update the cards' visibility based on the new transliteration state
        const cards = document.querySelectorAll(`.${cardType}`);
        cards.forEach((item) => {
            if (toggleState) {
                item.classList.remove('hidden');
            } else {
                item.classList.add('hidden');
            }
        });
    }

    const toggleTransliteration = () => {
        // Get the current translation settings from the React state (not localStorage directly)
        const newTransliterationState = !translationSettings.translit; // Toggle the translit state
        
        toggleTranslationPageCards('ayahTranslit',newTransliterationState);
    
        // Update the translationSettings state with the new translit state
        setTranslationSettings((prevSettings) => {
            const updatedSettings = { ...prevSettings, translit: newTransliterationState };
            // Save the updated settings to localStorage
            localStorage.setItem('translationSettings', JSON.stringify(updatedSettings));
            return updatedSettings;
        });
    };    

    const toggleAsdTranslate=()=>{
        // Get the current translation settings from the React state (not localStorage directly)
        const newTransliterationState = !translationSettings.asdTranslate; // Toggle the translit state
        
        toggleTranslationPageCards('ayahTransation1',newTransliterationState);
    
        // Update the translationSettings state with the new translit state
        setTranslationSettings((prevSettings) => {
            const updatedSettings = { ...prevSettings, asdTranslate: newTransliterationState };
            // Save the updated settings to localStorage
            localStorage.setItem('translationSettings', JSON.stringify(updatedSettings));
            return updatedSettings;
        });
    }

    const toggleMalTranslate=()=>{
        // Get the current translation settings from the React state (not localStorage directly)
        const newTransliterationState = !translationSettings.malikTranslate; // Toggle the translit state
        
        toggleTranslationPageCards('ayahTransation2',newTransliterationState);
    
        // Update the translationSettings state with the new translit state
        setTranslationSettings((prevSettings) => {
            const updatedSettings = { ...prevSettings, malikTranslate: newTransliterationState };
            // Save the updated settings to localStorage
            localStorage.setItem('translationSettings', JSON.stringify(updatedSettings));
            return updatedSettings;
        });
    }

    const toggleMktTranslate=()=>{
        // Get the current translation settings from the React state (not localStorage directly)
        const newTransliterationState = !translationSettings.mustafaTranslate; // Toggle the translit state
        
        toggleTranslationPageCards('ayahTransation3',newTransliterationState);
    
        // Update the translationSettings state with the new translit state
        setTranslationSettings((prevSettings) => {
            const updatedSettings = { ...prevSettings, mustafaTranslate: newTransliterationState };
            // Save the updated settings to localStorage
            localStorage.setItem('translationSettings', JSON.stringify(updatedSettings));
            return updatedSettings;
        });
    }
    
    const togglePikTranslate=()=>{
        // Get the current translation settings from the React state (not localStorage directly)
        const newTransliterationState = !translationSettings.piktcalTranslate; // Toggle the translit state
        
        toggleTranslationPageCards('ayahTransation4',newTransliterationState);
    
        // Update the translationSettings state with the new translit state
        setTranslationSettings((prevSettings) => {
            const updatedSettings = { ...prevSettings, piktcalTranslate: newTransliterationState };
            // Save the updated settings to localStorage
            localStorage.setItem('translationSettings', JSON.stringify(updatedSettings));
            return updatedSettings;
        });
    }

    const toggleYatTranslate=()=>{
        // Get the current translation settings from the React state (not localStorage directly)
        const newTransliterationState = !translationSettings.yusufTranslate; // Toggle the translit state
        
        toggleTranslationPageCards('ayahTransation5',newTransliterationState);
    
        // Update the translationSettings state with the new translit state
        setTranslationSettings((prevSettings) => {
            const updatedSettings = { ...prevSettings, yusufTranslate: newTransliterationState };
            // Save the updated settings to localStorage
            localStorage.setItem('translationSettings', JSON.stringify(updatedSettings));
            return updatedSettings;
        });
    }

    const translationOptions = [
        { id: "translit", label: "Enable" },
        { id: "asdTranslate", label: "Mohammad Asad" , toggleFunc: toggleAsdTranslate},
        { id: "malikTranslate", label: "Muhammad Farooq-i-Azam Malik" , toggleFunc: toggleMalTranslate},
        { id: "mustafaTranslate", label: "Mustafa Khattab", toggleFunc: toggleMktTranslate},
        { id: "piktcalTranslate", label: "Pickthall", toggleFunc: togglePikTranslate},
        { id: "yusufTranslate", label: "Abdullah Yusuf Ali", toggleFunc: toggleYatTranslate }
    ];

    useEffect(()=>{
        if(typeof translationSettings==="object")
        {
            translationSettingsStore.set(translationSettings);
            checkAllTranslationStatus();
        }
    },[translationSettings]);

    useEffect(() => {
        const unsubscribe = translationSettingsStore.subscribe(setTranslationSettings);
        return () => unsubscribe(); // Cleanup on unmount
    }, []);

    return(
        <div id="" className="">
            <h4 className="text-white my-6">Transliteration</h4>
            <label className="relative inline-flex items-center cursor-pointer">
                <input
                    type="checkbox"
                    checked={translationSettings.translit}
                    id={`react-${translationOptions[0].id}`}
                    onChange={toggleTransliteration}
                    className="sr-only peer"
                />
                <span className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></span>
                <span className="ml-3 text-sm font-medium text-white">Enable</span>
            </label>

            <h4 className="text-white my-6">Translation</h4>
            {translationOptions.slice(1).map((option, optionIndex) => (
                <label key={optionIndex} className="relative inline-flex items-center cursor-pointer w-full mb-3">
                    <input
                        type="checkbox"
                        id={`react-${option.id}`}
                        onChange={option.toggleFunc}
                        className="sr-only peer transToggle"
                        checked={translationSettings[option.id]}
                    />
                    <span className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></span>
                    <span className="ml-3 text-sm font-medium text-white">{option.label}</span>
                </label>
            ))}
        </div>
    );
}

export default TranslationSettings;